import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContextResolverService } from '../shared/sharedServices/contextResolver.service';
import { AuthRegisterComponent } from './pages/register/auth-register.component';
import { AuthVerifyCodeComponent } from './pages/verify-code/auth-verify-code.component';
import { AuthAccountDataComponent } from './pages/account-data/auth-account-data.component';
import { AuthPersonBillingComponent } from './pages/person-billing/auth-person-billing.component';
import { AuthCompanyBillingComponent } from './pages/company-billing/auth-company-billing.component';
import { LayoutAuthComponent } from '../layout/pages/layout-auth/layout-auth.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutAuthComponent,
    resolve: {
      context: ContextResolverService,
    },
    children: [
      {
        path: '',
        component: AuthRegisterComponent,
      },
      {
        path: 'verificacion',
        component: AuthVerifyCodeComponent,
      },
      {
        path: 'datos',
        component: AuthAccountDataComponent,
      },
      {
        path: 'facturacion',
        children: [
          {
            path: 'persona',
            component: AuthPersonBillingComponent,
          },
          {
            path: 'empresa',
            component: AuthCompanyBillingComponent,
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
